import React from "react";
import { Route, Switch } from "react-router-dom";
import Dashboard from "./../containers/Dashboard";
import Database from "./database/index";
import Attendance from "./attendance/index";
import Report from "./report/index";
import Event from "./event/index";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}dashboard`} component={Dashboard} />
      <Route path={`${match.url}database`} component={Database} />
      <Route path={`${match.url}attendance`} component={Attendance} />
      <Route path={`${match.url}report`} component={Report} />
      <Route path={`${match.url}event`} component={Event} />
    </Switch>
  </div>
);

export default App;
